var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.token === '' || _vm.disabled || _vm.selection.length != 0)?_c('TableFantasyLeague',{attrs:{"selection":_vm.selection}}):_c('FantasyLeagueSelection',{attrs:{"token":_vm.token},on:{"checkFantasyleague":_vm.check_fantasyleague}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }